const cardStyles = {
  display: "flex",
  padding: "10px",
  marginTop: "10px",
  flexDirection: "column",
  maxWidth:250,
  justifyContent: "space-between",
};

const cardSelectedStyles = {
  display: "flex",
  padding: "10px",
  marginTop: "10px",
  flexDirection: "column",
  maxWidth: 250,
  justifyContent: "space-between",
  border: "2px solid #37B34A",
};

const cardCartStyles = {
  display: "flex",
  padding: "10px",
  marginTop: "10px",
  alignItems: "center",
  width:1
};

const cardMediaStyles = { width: "100%", height: 80 };

const cardCartMediaStyles = { width: 42, height: 42 };

export {
  cardStyles,
  cardCartStyles,
  cardMediaStyles,
  cardCartMediaStyles,
  cardSelectedStyles,
};
